/* Figma V2 navigation. Commerce operations stay in their existing controllers. */
(function () {
  'use strict';
  function initHeader(header) {
    if (header.dataset.v2Initialised) return;
    header.dataset.v2Initialised = 'true';
    var dialog = header.querySelector('[data-v2-menu]');
    var opener = header.querySelector('[data-v2-menu-open]');
    var searchHandoff = false;
    if (!dialog || !opener) return;
    var nav = header.querySelector('.v2-header__nav');
    var more = header.querySelector('[data-v2-nav-more]');
    var categories = Array.from(header.querySelectorAll('[data-v2-nav-item]'));
    header.querySelectorAll('[data-v2-tabs]').forEach(initTabs);
    var navigationFont = '400 13px Suisseintl';
    var navigationFontReady = !document.fonts || document.fonts.check(navigationFont);
    var membership = '';
    function fitNavigation() {
      if (!nav || !more) return;
      if (!nav.clientWidth) {
        categories.forEach(function (item) { if (item.open) item.open = false; });
        more.open = false;
        return;
      }
      if (!navigationFontReady) return;
      categories.forEach(function (item) { item.hidden = false; });
      var gap = parseFloat(window.getComputedStyle(nav).columnGap) || 26;
      var used = more.querySelector('summary').getBoundingClientRect().width;
      var overflow = false;
      categories.forEach(function (item) {
        var label = item.querySelector('summary') || item;
        var width = label.getBoundingClientRect().width;
        overflow = overflow || used + gap + width > nav.clientWidth;
        item.hidden = overflow;
        if (!overflow) used += gap + width;
        var tab = more.querySelector('[data-v2-overflow-for="' + item.dataset.v2NavItem + '"]');
        if (tab) tab.hidden = !overflow;
      });
      var nextMembership = categories.map(function (item) { return item.hidden ? '0' : '1'; }).join('');
      if (nextMembership !== membership) {
        categories.forEach(function (item) { if (item.hidden && item.open) { item.open = false; more.querySelector('summary').focus(); } });
        var selected = more.querySelector('[role="tab"][aria-selected="true"]');
        if (!selected || selected.hidden) {
          var first = more.querySelector('[role="tab"]:not([hidden])');
          if (first) first.click();
        }
        membership = nextMembership;
      }
      nav.dataset.v2NavReady = 'true';
    }
    var resizeObserver;
    if (window.ResizeObserver && nav) { resizeObserver = new window.ResizeObserver(fitNavigation); resizeObserver.observe(nav); }
    window.addEventListener('resize', fitNavigation);
    if (!navigationFontReady) {
      var revealNavigation = function () {
        navigationFontReady = true;
        if (header.isConnected) fitNavigation();
      };
      document.fonts.load(navigationFont).then(revealNavigation, revealNavigation);
    }
    fitNavigation();
    function panel(id) {
      var active;
      dialog.dataset.v2MenuLevel = id;
      dialog.querySelectorAll('[data-v2-menu-panel]').forEach(function (node) {
        node.hidden = node.getAttribute('data-v2-menu-panel') !== id;
        if (!node.hidden) active = node;
      });
      if (active) {
        dialog.scrollTop = 0;
        var focus = active.querySelector('button,a');
        if (focus) focus.focus();
      }
    }
    opener.addEventListener('click', function () {
      panel('root');
      dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('v2-menu-open');
    });
    dialog.addEventListener('click', function (event) {
      var next = event.target.closest('[data-v2-menu-next],[data-v2-menu-back]');
      if (next) panel(next.getAttribute('data-v2-menu-next') || next.getAttribute('data-v2-menu-back'));
      if (event.target.closest('[data-v2-menu-search-open]')) { searchHandoff = true; dialog.close(); }
      if (event.target.closest('[data-v2-menu-close]') || event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', function () {
      opener.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('v2-menu-open');
      var search = searchHandoff ? document.querySelector('#SearchDrawer input[type="search"]') : null;
      searchHandoff = false;
      if (search) search.focus(); else opener.focus();
    });
    header.querySelectorAll('details').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) return;
        header.querySelectorAll('details').forEach(function (other) { if (other !== details) other.open = false; });
      });
      details.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); }
      });
    });
    function outsideClick(event) {
      if (!header.contains(event.target)) header.querySelectorAll('details[open]').forEach(function (node) { node.open = false; });
    }
    document.addEventListener('click', outsideClick);
    function unload(event) {
      if (!event.target.contains(header)) return;
      if (dialog.open) dialog.close();
      if (resizeObserver) resizeObserver.disconnect();
      window.removeEventListener('resize', fitNavigation);
      document.removeEventListener('click', outsideClick);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
  }
  function updateSamples(state) {
    if (!state) return;
    document.querySelectorAll('[data-v2-sample-count]').forEach(function (node) {
      node.textContent = 'Samples ' + state.totalUnits + '/' + state.maxSamples;
      node.closest('a').setAttribute('aria-label', 'Review ' + state.totalUnits + ' samples in ' + state.boxCount + ' boxes');
    });
  }
  function init(root) {
    root.querySelectorAll('[data-v2-library]').forEach(initLibrary);
    root.querySelectorAll('[data-v2-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-v2-header]').forEach(initHeader);
    root.querySelectorAll('[data-v2-sample-drawer]').forEach(initSamples);
    root.querySelectorAll('[data-v2-tabs]').forEach(initTabs);
    root.querySelectorAll('[data-v2-search-discovery]').forEach(initDiscovery);
    if (window.RPSampleBox) window.RPSampleBox.getState().then(updateSamples).catch(function () {});
  }
  function initLibrary(section) {
    if (section.dataset.v2Initialised) return;
    section.dataset.v2Initialised = 'true';
    var details = Array.from(section.querySelectorAll('details'));
    var desktop = window.matchMedia('(min-width: 1008px)');
    var mode;
    function layout() {
      if (mode === desktop.matches) return;
      mode = desktop.matches;
      details.forEach(function (node, index) { node.open = mode || index === 0; });
    }
    function toggle(event) {
      if (desktop.matches || !event.currentTarget.open) return;
      details.forEach(function (node) { if (node !== event.currentTarget) node.open = false; });
    }
    function unload(event) {
      if (!event.target.contains(section)) return;
      desktop.removeEventListener('change', layout);
      details.forEach(function (node) { node.removeEventListener('toggle', toggle); });
      document.removeEventListener('shopify:section:unload', unload);
      delete section.dataset.v2Initialised;
    }
    layout();
    desktop.addEventListener('change', layout);
    details.forEach(function (node) { node.addEventListener('toggle', toggle); });
    document.addEventListener('shopify:section:unload', unload);
  }
  function initCarousel(section) {
    if (section.dataset.v2Initialised) return;
    section.dataset.v2Initialised = 'true';
    var track = section.querySelector('[data-v2-carousel-track]');
    var buttons = section.querySelectorAll('[data-v2-carousel-direction]');
    var centred = section.dataset.v2CarouselCentred !== undefined;
    var startFirst = section.dataset.v2CarouselStart !== undefined;
    var previousDesktop;
    var userInteracted = false;
    var destroyDrag = initCarouselDrag(track, function () { userInteracted = true; update(); });
    function update() {
      if (window.PointerEvent) track.dataset.v2CarouselDraggable = String(track.scrollWidth > track.clientWidth + 1);
      buttons.forEach(function (button) {
        button.disabled = Number(button.dataset.v2CarouselDirection) < 0
          ? track.scrollLeft <= 1 : track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
      });
    }
    function layout() {
      if (centred) {
        var desktop = window.matchMedia('(min-width: 1008px)').matches;
        if (!userInteracted || desktop !== previousDesktop) {
          track.scrollLeft = desktop && !startFirst ? Math.max(0, (track.scrollWidth - track.clientWidth) / 2) : 0;
          userInteracted = false;
        }
        previousDesktop = desktop;
      }
      update();
    }
    if (centred) {
      ['pointerdown', 'wheel', 'keydown'].forEach(function (event) {
        track.addEventListener(event, function () { userInteracted = true; }, { passive: true });
      });
      track.addEventListener('focusin', function (event) {
        if (track.classList.contains('is-dragging')) return;
        var card = event.target.closest('.v2-card');
        if (!card || !track.contains(card)) return;
        userInteracted = true;
        var bounds = card.getBoundingClientRect();
        var viewport = track.getBoundingClientRect();
        var inset = parseFloat(window.getComputedStyle(track).scrollPaddingLeft) || 0;
        var left = bounds.left - viewport.left - inset;
        var right = bounds.right - viewport.right + inset;
        if (left < 0 || right > 0) {
          track.scrollBy({ left: left < 0 ? left : right,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }
      });
    }
    buttons.forEach(function (button) {
      button.addEventListener('click', function () {
        userInteracted = true;
        var card = track.querySelector('.v2-card');
        var gap = parseFloat(window.getComputedStyle(track).columnGap) || 16;
        var distance = card ? card.getBoundingClientRect().width + gap : track.clientWidth;
        track.scrollBy({ left: distance * Number(button.dataset.v2CarouselDirection),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      });
    });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', layout);
    function unload(event) {
      if (!event.target.contains(section)) return;
      destroyDrag();
      window.removeEventListener('resize', layout);
      document.removeEventListener('shopify:section:unload', unload);
    }
    document.addEventListener('shopify:section:unload', unload);
    layout();
  }
  function initCarouselDrag(track, interact) {
    if (!window.PointerEvent) return function () {};
    var pointer;
    var suppressClick = false;
    track.dataset.v2CarouselDraggable = 'true';
    function end(event) {
      if (!pointer) return;
      if (event && event.pointerId !== undefined && event.pointerId !== pointer.id) return;
      var id = pointer.id;
      pointer = null;
      track.classList.remove('is-dragging');
      window.removeEventListener('pointermove', move);
      window.removeEventListener('pointerup', end);
      window.removeEventListener('pointercancel', end);
      window.removeEventListener('blur', end);
      if (track.hasPointerCapture(id)) track.releasePointerCapture(id);
    }
    function start(event) {
      suppressClick = false;
      if (event.pointerType !== 'mouse' || event.button !== 0 || event.isPrimary === false) return;
      if (event.altKey || event.ctrlKey || event.metaKey || event.shiftKey ||
        track.scrollWidth <= track.clientWidth + 1 ||
        event.target.closest('button,input,select,textarea,[contenteditable="true"]')) return;
      end();
      pointer = { id: event.pointerId, x: event.clientX, y: event.clientY,
        scroll: track.scrollLeft, dragging: false };
      window.addEventListener('pointermove', move, { passive: false });
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
      window.addEventListener('blur', end);
    }
    function move(event) {
      if (!pointer || event.pointerId !== pointer.id) return;
      if (!event.buttons) { end(); return; }
      var distance = event.clientX - pointer.x;
      var vertical = Math.abs(event.clientY - pointer.y);
      if (!pointer.dragging) {
        if (Math.abs(distance) < 6) return;
        if (vertical > Math.abs(distance)) { end(); return; }
        pointer.dragging = true;
        suppressClick = true;
        track.classList.add('is-dragging');
        // Capture only after a drag begins so ordinary collection clicks keep their target.
        track.setPointerCapture(pointer.id);
      }
      event.preventDefault();
      track.scrollLeft = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, pointer.scroll - distance));
      interact();
    }
    function click(event) {
      if (!suppressClick || event.detail === 0) return;
      suppressClick = false;
      event.preventDefault();
      event.stopImmediatePropagation();
    }
    function nativeDrag(event) { if (pointer) event.preventDefault(); }
    track.addEventListener('pointerdown', start);
    track.addEventListener('lostpointercapture', end);
    track.addEventListener('dragstart', nativeDrag);
    track.addEventListener('click', click, true);
    return function () {
      end();
      track.removeEventListener('pointerdown', start);
      track.removeEventListener('lostpointercapture', end);
      track.removeEventListener('dragstart', nativeDrag);
      track.removeEventListener('click', click, true);
      delete track.dataset.v2CarouselDraggable;
    };
  }
  function initDiscovery(node) {
    if (node.dataset.v2Initialised) return;
    node.dataset.v2Initialised = 'true';
    var url = node.dataset.url + '?q=' + encodeURIComponent(node.dataset.query)
      + '&resources[type]=query,collection,page,article&resources[limit]=4&resources[limit_scope]=each&section_id=v2-search-discovery';
    fetch(url, { credentials: 'same-origin' }).then(function (response) {
      if (!response.ok) throw new Error('Discovery unavailable');
      return response.text();
    }).then(function (html) {
      if (!node.isConnected) return;
      var fragment = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-v2-search-discovery-fragment]');
      if (fragment) { node.replaceChildren(fragment); node.hidden = fragment.children.length === 0; }
    }).catch(function () {});
  }
  function initTabs(group) {
    if (group.dataset.v2Initialised) return;
    group.dataset.v2Initialised = 'true';
    var tabs = Array.from(group.querySelectorAll('[role="tab"]'));
    function activate(tab) {
      tabs.forEach(function (button) {
        var selected = button === tab;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
        var panel = group.querySelector('[id="' + button.getAttribute('aria-controls') + '"]');
        if (panel) panel.hidden = !selected;
      });
    }
    tabs.forEach(function (tab, index) {
      tab.addEventListener('click', function () { activate(tab); });
      tab.addEventListener('keydown', function (event) {
        var next;
        var visibleTabs = tabs.filter(function (button) { return !button.hidden; });
        var position = visibleTabs.indexOf(tab);
        var vertical = tab.closest('[role="tablist"]').getAttribute('aria-orientation') === 'vertical';
        if (event.key === (vertical ? 'ArrowDown' : 'ArrowRight')) next = visibleTabs[(position + 1) % visibleTabs.length];
        if (event.key === (vertical ? 'ArrowUp' : 'ArrowLeft')) next = visibleTabs[(position + visibleTabs.length - 1) % visibleTabs.length];
        if (event.key === 'Home') next = visibleTabs[0];
        if (event.key === 'End') next = visibleTabs[visibleTabs.length - 1];
        if (next) { event.preventDefault(); activate(next); next.focus(); }
      });
    });
    if (tabs.length) activate(tabs[0]);
  }
  function initSamples(dialog) {
    if (window.RPV2Samples) window.RPV2Samples.initDialog(dialog);
  }
  document.addEventListener('repubblica:sample_box_changed', function (event) { updateSamples(event.detail); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  // The header needs no cart API. Fit it before the later deferred scripts and DCL.
  document.querySelectorAll('[data-v2-header]').forEach(initHeader);
  // Other components still wait for the later cart API.
  if (document.readyState !== 'complete') document.addEventListener('DOMContentLoaded', function () { init(document); }, { once: true });
  else init(document);
})();
